import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null); // 'expert' ou 'client'
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // Fonction pour vérifier l'authentification
  const checkAuth = () => {
    console.log('🔍 Vérification de l\'authentification...');
    
    const expertToken = localStorage.getItem('expert_token');
    const clientToken = localStorage.getItem('client_token');
    
    console.log('🔐 Tokens trouvés:', {
      expertToken: expertToken ? 'Présent' : 'Absent',
      clientToken: clientToken ? 'Présent' : 'Absent'
    });

    if (expertToken) {
      console.log('✅ Authentifié en tant qu\'expert');
      setIsAuthenticated(true);
      setUserType('expert');
    } else if (clientToken) {
      console.log('✅ Authentifié en tant que client');
      setIsAuthenticated(true);
      setUserType('client');
    } else {
      console.log('❌ Aucun token valide trouvé');
      setIsAuthenticated(false);
      setUserType(null);
    }
    setIsLoading(false);
  };

  // Fonction de déconnexion
  const deconnexion = () => {
    console.log('🚪 Déconnexion en cours...');
    
    // Supprimer tous les tokens du localStorage
    localStorage.removeItem('expert_token');
    localStorage.removeItem('client_token');
    localStorage.removeItem('expert_info');
    localStorage.removeItem('client_info');
    localStorage.removeItem('token'); // Au cas où il y aurait d'autres tokens
    
    console.log('🗑️ Tokens supprimés du localStorage');
    
    // Mettre à jour l'état
    setIsAuthenticated(false);
    setUserType(null);
    
    console.log('📱 État d\'authentification mis à jour');
    
    // Rediriger vers la page de connexion
    navigate('/login');
    
    console.log('🎯 Redirection vers /login');
    
    // Optionnel : Afficher une notification
    // console.log('Déconnexion réussie');
  };

  // Vérifier l'authentification au montage du composant
  useEffect(() => {
    checkAuth();
  }, []);

  // Fonction pour obtenir le token actuel
  const getToken = () => {
    if (userType === 'expert') {
      return localStorage.getItem('expert_token');
    } else if (userType === 'client') {
      return localStorage.getItem('client_token');
    }
    return null;
  };

  return {
    isAuthenticated,
    userType,
    isLoading,
    checkAuth,
    deconnexion,
    getToken
  };
};

export default useAuth;